/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCookies } from "vue3-cookies";
import firebaseAuthService from "@/services/FirebaseAuthService";
import { COOKIE_USERNAME, COOKIE_TOKEN, COOKIE_DATA } from "@/utils/constants";

const { cookies } = useCookies();

const missingUserData = (store: any) => {
  const user = store.state.user;
  return user.token === "" || user.username === "" || !user.data;
};

export const reAuthorize = async (store: any) => {
  if (!store.state.user || missingUserData(store)) {
    try {
      // we have refreshed homepage and need to repopulate user in store
      const username = cookies.get(COOKIE_USERNAME);
      const token = cookies.get(COOKIE_TOKEN);
      const data = cookies.get(COOKIE_DATA);
      await store.dispatch("addUser", { username, token, data });
    } catch (e) {
      console.error("Problem refreshing user session");
      await firebaseAuthService.logout();
    }
  }
};
